/*eslint-disable*/

import React from "react";
import { Form, Button, Icon } from "semantic-ui-react";
import { usePlacesWidget } from "react-google-autocomplete";
import { isEmpty, omit } from "lodash";

// Styles
import styles from "./styles.module.css";

const AddressInput = (props) => {
	const { ref } = usePlacesWidget({
		apiKey: "AIzaSyB9eh4EYxyjQhXXOXMQBFOC4e5Ryvmlwn8",
		options: {
			fields: ["formatted_address", "geometry.location"],
			componentRestrictions: { country: "do" },
			types: [],
			debounce: 1000,
		},
		onPlaceSelected: (place) => {
			if (!isEmpty(place.geometry)) {
				const lat = place.geometry.location.lat();
				const lon = place.geometry.location.lng();
				props.getgeometry(lat, lon);
				onChange({ target: { name, value: place.formatted_address } });
			}
		},
	});

	const handleEnter = (e) => {
		const { key } = e;
		if (key === "Enter") {
			e.preventDefault();
		}
	};

	const clearInput = (e) => {
		const { name, onChange } = props;
		onChange({ ...e, target: { name, value: "" } });
	};

	const { name, onKeyPress, value, onChange, disabled, icon, className, rounded } = props;
	const validProps = omit(props, [
		"icon",
		"children",
		"getgeometry",
		"onKeyPress",
		"name",
		"value",
		"onChange",
		"disabled",
		"className",
		"rounded",
	]);
	return (
		<Form.Input
			{...validProps}
			className={`${styles.input} ${className}`}
			disabled={disabled}
			onChange={onChange}
			name={name}
			value={value}
			iconPosition="left"
			autoComplete="off"
			fluid
			onKeyPress={onKeyPress || handleEnter}
			action>
			<Icon name={icon} />
			<input ref={ref} />
			{!isEmpty(value) && !disabled && (
				<Button className={rounded ? styles.clearRoundedIconLast : styles.clearIconLast} icon="cancel" onClick={clearInput} />
			)}
		</Form.Input>
	);
};

export default AddressInput;
